
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.4 5.3H5.2l-.8-2.5c0-.2-.2-.3-.5-.3H.4v1h3c.1 0 .2.1.3.2l3.2 10.1c0 .1.2.2.4.2h10.3c.1 0 .2-.1.2-.2l1.8-8.3c0-.1-.1-.2-.2-.2zm-5.5 4.8l-.1 3H11l-.3-3h3.2zm-3.3-1l-.2-2.8H14l-.1 2.8h-3.3zm4.3 1h2.8l-.6 3h-2.3l.1-3zm2.9-1h-2.9l.1-2.8h3.4l-.6 2.8zM9.4 6.3l.2 2.8H6.4l-.9-2.8h3.9zm-2.7 3.8h3l.3 3H7.7l-1-3z"}}),_c('circle',{attrs:{"cx":"9.1","cy":"16.2","r":"1.3"}}),_c('circle',{attrs:{"cx":"15.9","cy":"16.2","r":"1.3"}})])
          )
        }
      }
    